import { call, put } from "redux-saga/effects";
import head from "lodash/head";
import isObject from "lodash/isObject";

import Http from "@api/http";
import { PATHS } from "@config";
import queryClient from "@config/queryClient";
import { QUERY_KEY } from "@config/queryKeys";
import { ACCESS_TOKEN_KEY, SEARCH_PARAMS } from "@config/storageKey";
import { loginFailed, loginSuccess, logoutFailed, logoutSuccess } from "@redux/auth/actions";
import { resetDefault } from "@redux/jobs/actions";
import { authLogin } from "@services/auth";
import { clearStorage, storageRemoveItem } from "@utils/storage";
import { deleteNotification } from "@pages/Settings/Notification/helper";
import actionTypes from "../actionTypes";

function login(accessToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  Http.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}

// eslint-disable-next-line consistent-return
function* authSaga({ type, payload }) {
  switch (type) {
    case actionTypes.DO_LOGIN:
      try {
        const res = yield call(authLogin, payload);
        if (res.success) {
          storageRemoveItem(SEARCH_PARAMS);
          yield put(loginSuccess(res));
          yield put(resetDefault());
          yield call(login, res.data.access_token);
        } else {
          let errorMsg = "";
          const errors = res?.data?.error_messages;
          if (isObject(errors)) {
            errorMsg = head(Object.values(errors));
          } else {
            errorMsg = errors;
          }
          yield put(loginFailed({ error: errorMsg }));
        }
      } catch (error) {
        yield put(loginFailed({ error }));
      }
      break;

    case actionTypes.DO_LOGOUT:
      try {
        yield deleteNotification();
        yield put(logoutSuccess());
        yield put(resetDefault());
        yield call(clearStorage);
        delete Http.defaults.headers.common.Authorization;
        Object.keys(QUERY_KEY).forEach((it) => {
          if (it !== QUERY_KEY.BANNER_HOME) queryClient.removeQueries(it);
        });
        yield call(payload.navigate, PATHS.LOGIN);
      } catch (error) {
        yield put(logoutFailed(error));
      }
      break;

    default:
      return null;
  }
}

export default authSaga;
